var map = {
	"./cloud-icon.png": 2211,
	"./code-icon.png": 3905,
	"./data-icon.png": 3252,
	"./deployment-icon.png": 5795,
	"./neural-icon.png": 4427,
	"./robot-icon.png": 2902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5682;